import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=665d32ca&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665d32ca')) {
      api.createRecord('665d32ca', component.options)
    } else {
      api.reload('665d32ca', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=665d32ca&", function () {
      api.rerender('665d32ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/comp/openstreetmap.vue"
export default component.exports